<template>
  <div class="main">
    <SideMenu />
    <Header title="Содержание" theme="white" />

    <div class="main-content">
      <MediaFiles />
    </div>
  </div>
</template>

<script>
import Header from "../components/Header/Header.vue";
import SideMenu from "../components/SideMenu/SideMenu.vue";
import MediaFiles from "@/components/MediaFiles/MediaFiles";

export default {
  name: "Media",
  components: {
    Header,
    MediaFiles,
    SideMenu,
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars.scss";

.main {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
}

.main-content {
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    margin: 100px 0 0 75px;
    padding: 0;
    min-height: 100vh;
    background: $white;
    overflow: auto;
}
</style>
